/*
Author: Chathuraka Mallawa Arachchi
Date: 18/10/2024
Copyright © 2024 Infix!. All rights reserved.

Responsible for managing frm state including validations.
*/

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'

export interface IanswerState {
    [key: string]: any
}

const initialState: IanswerState = {}

const formSlice = createSlice({
    name: 'answers',
    initialState,
    reducers: {
        updateAnswer: (
            state,
            action: PayloadAction<{
                field: keyof IanswerState
                value: any
            }>
        ) => {
            const { field, value } = action.payload
            state[field] = value
        },
        updateAnswers: (_state, action) => {
            return action.payload // Replaces the entire form state
        },
    },
})

export const { updateAnswer, updateAnswers } = formSlice.actions

export const useUpdateAnswer = () => {
    const dispatch = useDispatch()

    const updateAnswerValue = (field: keyof IanswerState, value: any) => {
        dispatch(updateAnswer({ field, value }))
    }

    return updateAnswerValue
}

export const useUpdateAnswers = () => {
    const dispatch = useDispatch()

    const updateUpdateAnswers = (value: any) => {
        dispatch(updateAnswers(value))
    }

    return updateUpdateAnswers
}

export default formSlice.reducer
